  
<loader-pane-fragment [trace]="traceNames.viewBudgetRevenue"></loader-pane-fragment>
<top-menu [showPrint]="true"></top-menu>

<div class="wrap100">
  <tip-text *ngIf="!hideTip" [type]="'tip'" [head]="'Tip'" [body]="revenueTip" [showClose]="true" (close)="hideRevenueTip()"></tip-text>
  <div class="header-strip" *ngIf="!!budget">
    <event-status [dotOnly]="false" [readOnly]="readOnly || closed"></event-status>
    <div style="flex:1;"></div>
    <div class="actions">
      <action-button *ngIf="!closed"  [text]="readOnly ? 'EDIT MODE' : 'VIEW MODE'" (click)="readOnly = !readOnly"></action-button>
      <h5 class="snapshot" [matMenuTriggerFor]="snapshot" *ngIf="!!budget?.revenueSnapshots?.length">
        <span>Share Versions</span><span class="down-arrow"></span>
      </h5>
      <action-button *ngIf="!closed" id="shareButton" [text]="'SHARE'" (click)="share($event)"></action-button>
      <action-button id="exportButton" [text]="'EXPORT'" (click)="export()"></action-button>
    </div>
  </div>
  <budget-totals-strip *ngIf="!!budget"
    [discount]="budget.revenueDiscount"
    [fees]="budget.revenueFees"
    [readOnly]="readOnly || closed"
    [subtotal]="budget.revenueSubtotal"
    [tax]="budget.revenueTax"
    [total]="budget.totalRevenue"
    [currency]="budget.currency"
    (changeCurrency)="changeCurrency($event)"
  ></budget-totals-strip>
</div>

<div class="wrap100 scrolling-body">
  <ng-container *ngFor="let revenueId of budget?.revenueIds; first as first; last as last; index as index;">
    <ng-container *ngIf="budget.sections[revenueId] as section">
      <tip-text 
        *ngIf="section.linkJustDeleted" [type]="'important'" 
        [body]="'The cost section this was linked from has been deleted.'"
        [showClose]="true"
        (close)="markDeletedLinkSection(revenueId)"
        ></tip-text>
      <budget-section 
        [first]="first"
        [last]="last"
        [viewMode]="!!readOnly || closed"
        [allowSectionOrdering]="!readOnly && !closed"
        (moveUp)="moveUp(index)"
        (moveDown)="moveDown(index)"
        [readOnly]="!!section.linkId || readOnly || closed"
        [section]="section"
        [isLinkedSection]="!!section.linkId"
        [canAddItems]="!section.linkId && !readOnly && !closed"
        (addItem)="addItem($event, section.id)"
        [hasChanges]="!!linkedChangedSectionsMap[section.id]"
        [budgetCurrency]="budget.currency"
        [gridData]="revenueGridDatas[section.id]" 
        (saveSection)="saveSection($event)"
        (changeSectionSettingDefaults)="saveSectionSettingDefaults($event)"
        (deleteSection)="deleteSection(index, revenueId)"
        (viewUpdates)="viewUpdates(section, linkedChangedSectionsMap[section.id])"
        [linkDropdownOptions]="section.linkId ? manageBudgetLinkDropdownOptions : null"
        (linkDropdownSelection)="manageLink(index, revenueId, $event)"
    ></budget-section>
    </ng-container>
  </ng-container>
  <div class="buttons-line" *ngIf="!readOnly && !closed">
    <button class="secondary" (click)="addSection()">+ ADD SECTION</button>
    <button *ngIf="!!linkableCostSections?.length" class="secondary" (click)="linkCostSection($event)">+ LINK COSTS</button>
  </div>
  <expanding-wrapper
    *ngIf="(!readOnly && !closed) || !!budget?.revenueFiles?.length"
    class="files"
    [title]="'File links (' + (budget?.revenueFiles?.length || 0) + ')'"
    [padded]="true"
    [borderGreyOnCollapse]="false">
    <file-handler 
      [data]="{ files: budget?.revenueFiles || [] }"
      [showNoFilesMessage]="!budget?.revenueFiles?.length"
      [namePlaceholder]="'Revenue File Link'"
      [noFilesMessage]="'No file links'"
      [hideByline]="true"
      (dataChange)="saveFiles($event)"
    ></file-handler> 
    <!--   [readfilesonly]="readOnly || closed" -->
  </expanding-wrapper>
  <expanding-wrapper
    *ngIf="(!readOnly && !closed) || !!budget?.revenuePaymentSchedule?.items.length"
    [title]="'Payment Schedule (' + (budget?.revenuePaymentSchedule?.items.length || 0) + ')'"
    [padded]="true"
    [borderGreyOnCollapse]="false">
    <budget-schedule
      [schedule]="budget?.revenuePaymentSchedule" 
      [hideTitle]="true"
      [gridData]="scheduleGridData"
      [readOnly]="readOnly || closed"
      (saveSchedule)="savePaymentSchedule($event)"
    ></budget-schedule>
  </expanding-wrapper>
</div>


<mat-menu #snapshot="matMenu" xPosition="before" class="snapshot_menus">
  <h5>SNAPSHOTS</h5>
  <div class="caption" *ngIf="!budget?.revenueSnapshots?.length">No snapshots</div>
  <div mat-menu-item class="item" *ngFor="let shot of budget?.revenueSnapshots" (click)="openSnapshot(shot)">
    <div class="name">{{ shot.name }}</div>
    <div class="time">{{ shot.timestamp | date:'h:mma, EEE d MMM'}}</div>
  </div>
  <mat-progress-spinner *ngIf="savingSnapshot" [diameter]="25" mode="indeterminate" color="primary"></mat-progress-spinner>
</mat-menu>

